import React from 'react';
import { useParams } from 'react-router-dom';
import Badge from 'src/components/Badge';
import { Box, Typography } from '@mui/material';
import { saveDataToStorage } from 'src/utils';
import { useStoreUnitActions } from 'src/redux/helpers';
import { useModal } from 'src/hooks';
import { isModalComplete } from 'src/components/ModalDialog';
import {
  DeploymentStatus,
  SolutionEdgeWorkloadItem,
  SolutionEdgeWorkloadRepositoryType,
  SolutionEdgeWorkloadStatus as Status,
} from 'src/pages/Solutions/types/solutionEdgeWorkload';
import SolutionWorkloadStatusViewModal from './SiteWorkloadStatusViewModal';
import sitesStore from '../../redux';

type Props = {
  value?: string;
  item?: SolutionEdgeWorkloadItem;
};

const buttonStyle = {
  textDecoration: 'underline',
  color: '#0047BA',
  cursor: 'pointer',
  fontWeight: 500,
  paddingLeft: '3px',
  fontSize: '13px',
};

function getDeploymentBadge(
  deploymentPaused: boolean,
  deploymentStatus: string,
  activeCount: number,
  totalCount: number,
  deploymentSummary: string
): { color: 'success' | 'warning' | 'error' | 'default' | 'info'; label: string } {
  if (deploymentPaused) {
    return { color: 'info', label: deploymentStatus || 'Paused' };
  }
  if (totalCount > 0 && activeCount === totalCount) {
    return { color: 'success', label: `${deploymentSummary} Active` };
  }
  if (totalCount > activeCount && activeCount > 0) {
    return { color: 'warning', label: `${deploymentSummary} Error` };
  }
  if (totalCount > 0 && activeCount === 0) {
    return { color: 'error', label: `${deploymentSummary} Failed` };
  }
  return { color: 'default', label: deploymentSummary || '-' };
}

function SolutionEdgeWorkloadStatus({ value = '', item }: Props) {
  let statusData: any = {};
  try {
    statusData = value ? JSON.parse(value) : {};
  } catch {
    statusData = {};
  }
  const deploymentSummary: string = statusData?.deploymentSummary ?? '';
  const activeDeploymentCount: number = statusData?.activeDeploymentCount ?? 0;
  const totalDeploymentCount: number = statusData?.totalDeploymentCount ?? 0;
  const deploymentPaused: boolean = statusData?.deploymentPaused ?? false;
  const errorMsg: string = statusData?.errorMsg ?? '';
  const statusValue: Status = statusData?.status
    ? statusData.status.toLowerCase()
    : '';

  const { siteId } = useParams();
  const actions = useStoreUnitActions(sitesStore);

  const onClose = (reason) =>
    isModalComplete(reason) && actions.edgeWorkloadConfigurations(siteId);

  const [workloadStatusDialog, showWorkloadStatusDialog] = useModal(
    SolutionWorkloadStatusViewModal,
    { item, onClose }
  );

  const badge = getDeploymentBadge(
    deploymentPaused,
    statusData?.status || '',
    activeDeploymentCount,
    totalDeploymentCount,
    deploymentSummary
  );

  return (
    <Box>
      <Badge color={badge.color} label={badge.label} />
      {/* {!deploymentPaused && (statusValue === Status.notReady || errorMsg) && (
        <Typography
          sx={{
            display: '-webkit-box',
            color: '#DB1E36',
            fontSize: '13px',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            textOverflow: 'ellipsis',
            wordBreak: 'break-all',
            overflow: 'hidden',
            whiteSpace: 'normal',
          }}
        >
          {errorMsg}
        </Typography>
      )} */}
      {workloadStatusDialog}
    </Box>
  );
}

export default SolutionEdgeWorkloadStatus;
